module.exports = __webpack_public_path__ + "media/stylesheets/images/rulers_@2X-780cdce3e3abc57fa7b76b6b95eebfc7.png";